import { KeyboardEventHandler, ReactEventHandler } from 'react'

import { INPUT_INT_NUMBER_ACCEPT_KEYS } from '@constants'

export const limitIntEntry: KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement> = e => {
  if (!INPUT_INT_NUMBER_ACCEPT_KEYS.includes(e.key)) {
    e.preventDefault()
  }
}

export const preventEvent: ReactEventHandler = e => {
  e.preventDefault()
}
